(function () {
  function initMarquee(root) {
    var track = root.querySelector('[data-marquee-track]');
    if (!track) return;

    var rebuild = function () {
      var originals = [];
      var child;
      var i;

      for (i = 0; i < track.children.length; i++) {
        child = track.children[i];
        if (child.getAttribute('data-marquee-clone') !== 'true') {
          originals.push(child);
        }
      }

      if (!originals.length) return;

      var clones = track.querySelectorAll('[data-marquee-clone="true"]');
      for (i = 0; i < clones.length; i++) {
        clones[i].parentNode.removeChild(clones[i]);
      }

      var setWidth = track.scrollWidth;
      if (!setWidth) return;

      var containerWidth = root.offsetWidth || window.innerWidth;
      var cloneSets = Math.ceil(1 + containerWidth / setWidth);
      cloneSets = Math.min(Math.max(cloneSets, 1), 12);

      var fragment = document.createDocumentFragment();
      for (var set = 0; set < cloneSets; set++) {
        for (i = 0; i < originals.length; i++) {
          child = originals[i].cloneNode(true);
          child.setAttribute('data-marquee-clone', 'true');
          child.setAttribute('aria-hidden', 'true');
          fragment.appendChild(child);
        }
      }

      track.appendChild(fragment);
      track.style.setProperty('--marquee-distance', setWidth + 'px');
    };

    var scheduleRebuild = function () {
      window.requestAnimationFrame(rebuild);
    };

    scheduleRebuild();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(scheduleRebuild, 150);
    });

    if ('ResizeObserver' in window) {
      var observer = new ResizeObserver(function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(scheduleRebuild, 150);
      });
      observer.observe(root);
    }
  }

  function boot() {
    var marquees = document.querySelectorAll('[data-rabitat-marquee]');
    for (var i = 0; i < marquees.length; i++) {
      initMarquee(marquees[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
